import StorageBox from "Store/StorageBox.js";
import PersonalStorageKeys from "Utility/PersonalStorageKey.js";
class UserBaseUtils {
  constructor() {}

  getUserName() {
    var Username = StorageBox.getUserName();
    if (Username != null) {
      return Username;
    } else {
      return "Public/Anonymous";
    }
  }

  getProfileUserName() {
    var Username = StorageBox.getProfileUserName();
    if (Username != null) {
      return Username;
    } else {
      return "Public/Anonymous";
    }
  }
}

export default new UserBaseUtils();
